export const OrderIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.1268 14.2695C16.4586 14.2695 15.1016 15.6266 15.1016 17.2947C15.1016 18.9629 16.4586 20.32 18.1268 20.32C19.7952 20.32 21.152 18.9629 21.152 17.2947C21.152 15.6266 19.7949 14.2695 18.1268 14.2695ZM18.1268 18.8074C17.2926 18.8074 16.6142 18.1289 16.6142 17.2947C16.6142 16.4606 17.2926 15.7821 18.1268 15.7821C18.961 15.7821 19.6394 16.4606 19.6394 17.2947C19.6394 18.129 18.961 18.8074 18.1268 18.8074Z"
        fill="#99A0AE"
      />
      <path
        d="M7.79084 14.2695C6.1227 14.2695 4.76562 15.6266 4.76562 17.2947C4.76562 18.9629 6.1227 20.32 7.79084 20.32C9.45898 20.32 10.8161 18.9629 10.8161 17.2947C10.8161 15.6266 9.45898 14.2695 7.79084 14.2695ZM7.79084 18.8074C6.95666 18.8074 6.27823 18.1289 6.27823 17.2947C6.27823 16.4606 6.95666 15.7821 7.79084 15.7821C8.6248 15.7821 9.30345 16.4606 9.30345 17.2947C9.30345 18.129 8.62503 18.8074 7.79084 18.8074Z"
        fill="#99A0AE"
      />
      <path
        d="M20.1669 5.60789C20.0383 5.35252 19.7769 5.19141 19.491 5.19141H15.5078V6.70402H19.0246L21.084 10.8001L22.4358 10.1205L20.1669 5.60789Z"
        fill="#99A0AE"
      />
      <path d="M15.8555 16.5625H10.1328V18.0751H15.8555V16.5625Z" fill="#99A0AE" />
      <path
        d="M5.51872 16.5625H2.89691C2.47916 16.5625 2.14062 16.9011 2.14062 17.3188C2.14062 17.7365 2.4792 18.0751 2.89691 18.0751H5.51877C5.93652 18.0751 6.27505 17.7365 6.27505 17.3188C6.27505 16.901 5.93647 16.5625 5.51872 16.5625Z"
        fill="#99A0AE"
      />
      <path
        d="M23.8389 11.9385L22.3513 10.0225C22.2084 9.83798 21.9878 9.73008 21.7541 9.73008H16.2582V4.43597C16.2582 4.01822 15.9197 3.67969 15.502 3.67969H2.89691C2.47916 3.67969 2.14062 4.01827 2.14062 4.43597C2.14062 4.85367 2.4792 5.19225 2.89691 5.19225H14.7456V10.4864C14.7456 10.9041 15.0842 11.2426 15.5019 11.2426H21.3837L22.4851 12.6615V16.562H20.3927C19.9749 16.562 19.6364 16.9005 19.6364 17.3182C19.6364 17.736 19.975 18.0745 20.3927 18.0745H23.2414C23.6592 18.0745 23.9977 17.736 23.9977 17.3182V12.4024C23.9977 12.2345 23.9418 12.0711 23.8389 11.9385Z"
        fill="#99A0AE"
      />
      <path
        d="M5.46967 12.7305H1.99066C1.57291 12.7305 1.23438 13.069 1.23438 13.4868C1.23438 13.9045 1.57295 14.243 1.99066 14.243H5.46962C5.88737 14.243 6.22591 13.9045 6.22591 13.4868C6.22595 13.069 5.88737 12.7305 5.46967 12.7305Z"
        fill="#99A0AE"
      />
      <path
        d="M7.21008 9.75781H0.756281C0.338578 9.75781 0 10.0964 0 10.5141C0 10.9319 0.338578 11.2704 0.756281 11.2704H7.21008C7.62783 11.2704 7.96636 10.9318 7.96636 10.5141C7.96636 10.0964 7.62783 9.75781 7.21008 9.75781Z"
        fill="#99A0AE"
      />
      <path
        d="M8.44445 6.78125H1.99066C1.57291 6.78125 1.23438 7.11983 1.23438 7.53753C1.23438 7.95528 1.57295 8.29381 1.99066 8.29381H8.44445C8.8622 8.29381 9.20073 7.95523 9.20073 7.53753C9.20078 7.11983 8.8622 6.78125 8.44445 6.78125Z"
        fill="#99A0AE"
      />
    </svg>
  );
};
